import i18n from '@/plugins/i18n';

const { t } = i18n.global;

export default Object.freeze({
  INITIALIZED: { value: 1, color: '#64748B', text: t('initialized') }, // slate / neutral
  PENDING: { value: 2, color: '#F59E0B', text: t('pending') }, // amber / waiting
  ACCEPTED: { value: 3, color: '#16A34A', text: t('accepted') }, // green / success
  FAILED: { value: 4, color: '#DC2626', text: t('failed') }, // red / error
  REJECTED: { value: 5, color: '#B91C1C', text: t('rejected') }, // dark red
  REFUND: { value: 6, color: '#2563EB', text: t('refund') }, // blue / info
  CANCELED: { value: 7, color: '#6B7280', text: t('canceled') }, // gray / inactive
});
